import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'

export type GenerateHandoverQrRequest = {
  deliveryId: string
  deviceId: string
}

export type GenerateHandoverQrResponse = {
  token: string
  expires_at: string
}

const QR_TTL_MS = 15 * 60 * 1000

function mockQr(req: GenerateHandoverQrRequest): GenerateHandoverQrResponse {
  const expires = new Date(Date.now() + QR_TTL_MS)
  return {
    token: `HOV-${req.deliveryId}-${expires.getTime().toString(36).toUpperCase()}`,
    expires_at: expires.toISOString(),
  }
}

export async function generateHandoverQrDirect(
  req: GenerateHandoverQrRequest,
): Promise<GenerateHandoverQrResponse> {
  if (shouldUseDelmanMock()) {
    await new Promise((r) => setTimeout(r, 350))
    return mockQr(req)
  }

  return apiFetch<GenerateHandoverQrResponse>(
    `/deliveries/${encodeURIComponent(req.deliveryId)}/generate-qr`,
    {
      method: 'POST',
      body: JSON.stringify({ device_id: req.deviceId }),
    },
  )
}

export async function generateHandoverQr(
  req: GenerateHandoverQrRequest,
): Promise<GenerateHandoverQrResponse> {
  return runKitchenSync(
    {
      type: 'delman_handover_qr',
      label: `QR handover ${req.deliveryId}`,
      payload: req,
    },
    () => generateHandoverQrDirect(req),
    () => mockQr(req),
  )
}

export function isQrExpired(expiresAt: string | undefined): boolean {
  if (!expiresAt) return true
  return new Date(expiresAt).getTime() <= Date.now()
}
